import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
export var useHeaderIndent = function useHeaderIndent(elementRef) {
  useEffect(function () {
    var observingElement = elementRef.current;
    var headerElement = document.querySelector('[data-component="site-header"]');
    var observer = new ResizeObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      if (headerElement) headerElement.style.height = "".concat(entry.contentRect.height, "px");
    });
    if (observingElement) {
      observer.observe(observingElement);
    }
    return function () {
      observer.unobserve(observingElement);
    };
  }, []);
};